__turbopack_context__.v({
  "card": "category_cards-module-scss-module__PfDjYq__card",
  "image-wrapper": "category_cards-module-scss-module__PfDjYq__image-wrapper",
  "text": "category_cards-module-scss-module__PfDjYq__text",
});
